module.exports = ":host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start; }\n  :host .mat-icon {\n    margin-top: -10px; }\n  :host img {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    margin-right: 16px;\n    border: 1px solid #e6e6e6; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/list-item/list-item.component.scss
// module id = ./src/app/shared/list-item/list-item.component.scss
// module chunks = main